import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Status } from '../../../models/masterdata.model';
import { DataContextService } from '../../../services/datacontext.service';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusComponent {
  @Input() withLabel = true;
  @Input() withBorder = false;
  @Input() set status(val: string) {
    if (!!val){
      this.class = val.toLowerCase();
      this.label = this.statuses.find(i => i.name === val)?.displayName;
    }
  }
  private statuses: Status[] = [];
  constructor(private dataContextService: DataContextService) {
    dataContextService.masterDadaLoaded$.subscribe((val: boolean) => {
      if (val) {
        this.statuses = [
          ...DataContextService.BookingStatus,
          ...DataContextService.MeetingWaitlistStatus,
          ...DataContextService.VirtualBookingStatus,
          ...DataContextService.ReservationStatus,
          ...DataContextService.TaskStatus,
          ...DataContextService.CateringStatus,
          ...DataContextService.WaitlistStatus
        ];
      }
    })
  }

  class: string;
  label: string;
}
